import { SET_LANGUAGE } from "../utils/Constants";

export const setLanguage = (data) => {
  return { type: SET_LANGUAGE, data: data };
};
